import { render, staticRenderFns } from "./BookItem.vue?vue&type=template&id=63e606ca&scoped=true&"
import script from "./BookItem.vue?vue&type=script&lang=js&"
export * from "./BookItem.vue?vue&type=script&lang=js&"
import style0 from "./BookItem.vue?vue&type=style&index=0&id=63e606ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e606ca",
  null
  
)

export default component.exports